import { render, staticRenderFns } from "./luckdraw.vue?vue&type=template&id=c2015698&"
import script from "./luckdraw.vue?vue&type=script&lang=js&"
export * from "./luckdraw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports